customElements.get("product-info") || customElements.define("product-info", class t extends HTMLElement {
    constructor() {
        super(),
            this.input = this.querySelector(".quantity__input"), this.currentVariant = this.querySelector(".product-variant-id"),
            this.variantSelects = this.querySelector("variant-radios"), this.submitButton = this.querySelector('[type="submit"]')
    }
    cartUpdateUnsubscriber = void 0;
    variantChangeUnsubscriber = void 0;
    onVariantClick(t) {
        this.variantLabel.forEach(i => {
            i.innerText.includes(t.target.name) && (i.querySelector("strong").innerHTML = t.target.value)
        })
    }
    connectedCallback() {
        this.input && (this.quantityForm = this.querySelector(".product-form__quantity"), this.quantityForm && (this.setQuantityBoundries(), this.dataset.originalSection || (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))), this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, t => {
            let i = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
            t.data.sectionId === i && (this.updateQuantityRules(t.data.sectionId, t.data.html), this.setQuantityBoundries())
        })))
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(), this.variantChangeUnsubscriber && this.variantChangeUnsubscriber()
    }
    setQuantityBoundries() {
        let t = {
                cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
                min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
                max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
                step: this.input.step ? parseInt(this.input.step) : 1
            },
            i = t.min,
            e = null === t.max ? t.max : t.max - t.cartQuantity;
        null !== e && (i = Math.min(i, e)), t.cartQuantity >= t.min && (i = Math.min(i, t.step)), this.input.min = i, this.input.max = e, this.input.value = i, publish(PUB_SUB_EVENTS.quantityUpdate, void 0)
    }
    fetchQuantityRules() {
        this.currentVariant && this.currentVariant.value && (this.querySelector(".quantity__rules-cart .loading__spinner").classList.remove("hidden"), fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then(t => t.text()).then(t => {
            let i = new DOMParser().parseFromString(t, "text/html");
            this.updateQuantityRules(this.dataset.section, i), this.setQuantityBoundries()
        }).catch(t => {
            console.error(t)
        }).finally(() => {
            this.querySelector(".quantity__rules-cart .loading__spinner").classList.add("hidden")
        }))
    }
    updateQuantityRules(t, i) {
        let e = i.getElementById(`Quantity-Form-${t}`);
        for (let a of [".quantity__input", ".quantity__rules", ".quantity__label"]) {
            let n = this.quantityForm.querySelector(a),
                s = e.querySelector(a);
            if (n && s) {
                if (".quantity__input" === a) {
                    let r = ["data-cart-quantity", "data-min", "data-max", "step"];
                    for (let u of r) {
                        let l = s.getAttribute(u);
                        null !== l && n.setAttribute(u, l)
                    }
                } else n.innerHTML = s.innerHTML
            }
        }
    }
});